// @TODO: Icon support

import { keyframes } from "@emotion/react";

import { toRem, toRems } from "../../../../helpers/theme";
import { normalizeDimension } from "../../../../helpers/utils";

const animAutoFill = keyframes({ from: {} });
const animAutoFillCancel = keyframes({ from: {} });

const style = ({
    theme,
    labelAlignLeft,
    size,
    variant,
    inputType,
    fieldWidth,
    inputWidth,
    disabled,
    focused,
    hasBottomSpacing,
    isActionComponentTitle,
    error,
}) => {
    const config = {
        fontSize: 16,
        borderRadius: 100,
        normal: {
            padding: [10, 22],
            height: 48,
            fontWeight: theme.typography.fontWeight.regular,
        },
        large: {
            padding: [10, 22],
            height: 62,
            fontWeight: theme.typography.fontWeight.bold,
        },
    };

    return {
        position: "relative",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        ...(fieldWidth && {
            maxWidth: normalizeDimension(fieldWidth, true),
        }),
        ...(inputType === "hidden" && {
            display: "none!important",
        }),
        ...(hasBottomSpacing && {
            marginBottom: toRem(30),
        }),
        [theme.breakpoints.up("md")]: {
            ...(labelAlignLeft && {
                flexDirection: "row",
                alignItems: "flex-start",
            }),
        },
        "& .inputContainer": {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            alignItems: "flex-start",
            width: "100%",
            "&_inner": {
                display: "flex",
                flexDirection: "row",
                flex: 1,
                width: "100%",
            },
        },
        "& .inputWrap": {
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            boxSizing: "border-box",
            alignItems: "center",
            width: "100%",
            background: error
                ? theme.colors.form.error.background
                : theme.colors.form.input[variant]?.background?.default,
            border: "1px solid",
            borderColor: error
                ? theme.colors.form.error.border
                : theme.colors.form.input[variant]?.border?.default,
            borderRadius: toRem(config.borderRadius),
            boxShadow: "none",
            transitionDuration: theme.transitions.input.text.default.duration,
            transitionTimingFunction: theme.transitions.input.text.default.timingFunction,
            transitionDelay: theme.transitions.input.text.default.delay,
            transitionProperty: "color, background, border-color, box-shadow",
            ...(inputWidth && {
                maxWidth: normalizeDimension(inputWidth, true),
            }),
            ...(focused && {
                outline: 0,
                background: error
                    ? theme.colors.form.error.background
                    : theme.colors.form.input[variant]?.background?.focus,
                borderColor: error
                    ? theme.colors.form.error.border
                    : theme.colors.form.input[variant]?.border?.focus,
                boxShadow: error ? "none" : theme.shadows.input.focus,
            }),
            ...(disabled && {
                cursor: "not-allowed",
            }),
            [theme.breakpoints.up("md")]: {
                ...(labelAlignLeft && {
                    flex: 1,
                }),
            },
            "&:hover": {
                ...(!disabled && {
                    borderColor: error
                        ? theme.colors.form.error.border
                        : theme.colors.form.input[variant]?.border?.hover,
                }),
            },
            input: {
                font: "inherit",
                color: error
                    ? theme.colors.form.error.text
                    : theme.colors.form.input[variant]?.text?.default,
                padding: toRems(config[size]?.padding),
                border: 0,
                borderRadius: toRem(config.borderRadius),
                boxSizing: "border-box",
                background: error ? theme.colors.form.error.background : "none",
                height: toRem(config[size]?.height),
                margin: 0,
                WebkitTapHighlightColor: "transparent",
                display: "block",
                minWidth: 0,
                width: "100%",
                fontSize: toRem(config.fontSize),
                fontWeight: config[size]?.fontWeight,
                animationDuration: "10ms",
                animationName: animAutoFillCancel,
                "&::placeholder": {
                    color: error
                        ? theme.colors.form.error.text
                        : theme.colors.form.input[variant]?.text?.placeholder,
                    opacity: 1,
                },
                "&:focus": {
                    outline: 0,
                },
                "&:disabled": {
                    cursor: "not-allowed",
                    color: theme.colors.form.input[variant]?.text?.disabled,
                },
                "&:invalid": {
                    boxShadow: "none",
                },
                "&:-webkit-autofill": {
                    animationDuration: "5000s",
                    animationName: animAutoFill,
                },
                ...(inputType === "search" && {
                    MozAppearance: "textfield",
                    WebkitAppearance: "textfield",
                }),
            },
        },
        "& .inputAction": {
            display: "flex",
            margin: toRems([4, 12, 4, 0]),
            ...(isActionComponentTitle && {
                position: "absolute",
                right: 0,
                bottom: toRem(-20),
            }),
        },
    };
};

export default style;
